import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  selector: 'app-terms-page',
  templateUrl: './terms-page.component.html',
  styleUrls: ['./terms-page.component.scss']
})
export class TermsPageComponent implements OnInit {
  data$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor(
    private readonly http: HttpClient,
    private readonly translate: TranslateService,
    public authService: AuthService
  ) {}

  ngOnInit(): void {
    const lang = this.translate.currentLang || this.translate.getDefaultLang();
    this.loadTerms(lang);
  }

  private loadTerms(lang: string) {
    this.http.get(`/assets/i18n/pages/terms/${lang}.html`, { responseType: 'text' }).subscribe((html) => {
      this.data$.next(html);
    });
  }
}
